import { useSelector, useDispatch } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  resetSelectedProduct,
  setSelectedProduct,
} from '../data/flatRateOffers/actions';
import { selectFlatRateOffersProductFamily } from '../data/flatRateOffers/selectors';
import { productFamilyThemeClass } from '../constants/productFamily';

export const useFlatRateOffersProductFamily = () => {
  const selectedProduct = useSelector(selectFlatRateOffersProductFamily);
  const dispatch = useDispatch();
  const setProduct = useCallback(
    productId => {
      dispatch(setSelectedProduct(productId));
    },
    [dispatch]
  );
  return [selectedProduct, setProduct];
};

export const useResetFlatRateOffersProductFamilyOnExit = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetSelectedProduct());
    };
  }, [dispatch]);
};

export const useFlatRateOffersProductFamilyTheme = () => {
  const selectedProduct = useSelector(selectFlatRateOffersProductFamily);
  return productFamilyThemeClass(selectedProduct);
};
